export default __webpack_public_path__ + "static/montserrat-v15-latin-800-73e35d72ee4169a6194c84c7c9a15595.ttf";